module.exports = __webpack_public_path__ + "static/img/preview.3d0ff29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/lopez-tonight-banner-campaign/preview.png
// module id = 99
// module chunks = 2